export const MessageActions = {
  inserted: 'Inserted',
  marked_as_read: 'Marked_As_Read',
  deleted: 'Deleted',
  updated: 'Updated',
};

export const MESSAGE_EVENT_NAME = 'CommentChanged';
export const NOTIFICATION_EVENT_NAME = 'N20_Notification';
